import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useLogoutMutation } from '@/queries/auth/useLogoutMutation';
import OrgSwitcher from './OrgSwitcher';

export default function HeaderComponent({ withHeader }) {
  const logoutMutation = useLogoutMutation();

  const logout = () => {
    logoutMutation.mutate();
  };

  if (!withHeader) {
    return null;
  }

  return (
    <header className="sticky top-0 z-[var(--bethere-z-header)] w-full border-b border-black/[0.08] bg-white/65 backdrop-blur-xl supports-[backdrop-filter]:bg-white/55">
      <div className="mx-auto grid w-full max-w-[var(--bethere-max-width)] grid-cols-[1fr_auto_1fr] items-center gap-[var(--bethere-gap-lg)] px-[var(--bethere-gap-md)] py-[var(--bethere-gap-md)]">
        <Link
          className="inline-flex min-h-0 min-w-0 shrink items-center justify-self-start no-underline"
          to="/"
        >
          <span className="text-xl font-bold tracking-tight text-[#121212]">
            {import.meta.env.MODE === 'development'
              ? ' Hum Events - Dev'
              : 'Hum'}
          </span>
        </Link>
        <div className="justify-self-center">
          <OrgSwitcher />
        </div>
        <div className="flex items-center justify-end justify-self-end gap-[var(--bethere-gap-lg)]">
          <nav className="bethere-header-nav" aria-label="Main navigation">
            <NavLink to="/account" activeClassName="active">
              Account
            </NavLink>
            <NavLink to="/" exact activeClassName="active">
              Event Management
            </NavLink>
          </nav>
          <button
            type="button"
            disabled={logoutMutation.isPending}
            className="bethere-header-logout-btn shrink-0"
            onClick={logout}
          >
            Log Out
          </button>
        </div>
      </div>
    </header>
  );
}
